var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-container",style:({
    gridRow: ((_vm.project.row) + " / span 4"),
  })},_vm._l((_vm.project.images),function(image,index){return _c('img',{key:image.url,style:({
      maxHeight: '100%',
      display: index > 0 && _vm.isMobile ? 'none' : 'block',
      zIndex: 10 - index,
    }),attrs:{"src":_vm.getImgUrl(image),"alt":image},on:{"click":_vm.showModal}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }